import '../css/base.css';
import '../js/flexible.js';
import '../js/zepto.js';


// WEBPACK FOOTER //
// ./mobile/src/router/global.js